import { render, staticRenderFns } from "./Rankrequest.vue?vue&type=template&id=05143ca0&scoped=true"
import script from "./Rankrequest.vue?vue&type=script&lang=js"
export * from "./Rankrequest.vue?vue&type=script&lang=js"
import style0 from "./Rankrequest.vue?vue&type=style&index=0&id=05143ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05143ca0",
  null
  
)

export default component.exports